import api from './api';

const authService = {
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    const payload = response?.data || response;
    if (payload?.token) {
      localStorage.setItem('token', payload.token);
      localStorage.setItem('user', JSON.stringify(payload.data));
    }
    return response;
  },
  sendVerificationCode: ({ email, purpose }) => api.post('/auth/send-code', { email, purpose }),
  checkEmail: (email) => api.get(`/auth/check-email?email=${encodeURIComponent(email)}`),
  clearAiProfile: () => api.post('/auth/clear-ai-profile'),

  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    const payload = response?.data || response;
    if (payload?.token) {
      localStorage.setItem('token', payload.token);
      localStorage.setItem('user', JSON.stringify(payload.data));
    }
    return response;
  },

  guestLogin: async () => {
    const response = await api.post('/auth/guest', {});
    const payload = response?.data || response;
    if (payload?.token) {
      localStorage.setItem('token', payload.token);
      localStorage.setItem('user', JSON.stringify(payload.data));
    }
    return response;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getProfile: () => api.get('/auth/profile'),

  updateProfile: (userData) => api.put('/auth/profile', userData),
  changePassword: (data) => api.put('/auth/change-password', data),

  resetPassword: (data) => api.post('/auth/forgot-password/reset', data),
};

export default authService;
